import { Tray, Theme } from '@busybusy/webapp-react-ui';
import { DeleteIcon } from 'assets/icons';
import { ActionBar, IconButton } from 'components';
import { t } from 'i18next';

export interface ICertificationStatusActionBarProps {
  onDelete: () => void;
  onClear: () => void;
  checkedIds: string[];
}

const CertificationStatusActionBar = (props: ICertificationStatusActionBarProps) => {
  const { onDelete, checkedIds, onClear } = props;

  return (
    <>
      <ActionBar selectedCount={checkedIds.length} onClear={onClear}>
        <Tray spacing={1}>
          <IconButton svg={DeleteIcon} onClick={onDelete} tooltipLabel={t('Delete')} theme={Theme.DARK} />
        </Tray>
      </ActionBar>
    </>
  );
};

export default CertificationStatusActionBar;
